// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2Xa1l";
var _4 = "wrapper_info-2nDmJ";
var _5 = "wrapper_stophint-1OJzJ";
var _6 = "wrapper_warning-3Q7c5";
var _7 = "wrapper_promo-2A1nj";
var _8 = "stopHint-5tskI";
var _9 = "terminalChanger-205LK";
var _a = "value-2pUZQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "wrapper_info", _5 as "wrapper_stophint", _6 as "wrapper_warning", _7 as "wrapper_promo", _8 as "stopHint", _9 as "terminalChanger", _a as "value" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "wrapper_info": _4, "wrapper_stophint": _5, "wrapper_warning": _6, "wrapper_promo": _7, "stopHint": _8, "terminalChanger": _9, "value": _a }
